<template>
  <div class="employee-badge-counter" @click="$emit('click')">
    <div
      v-for="level in badgeLevels"
      :key="level.key"
      class="employee-badge-counter__badge"
      :class="`employee-badge-counter__badge--${level.key}`"
    >
      {{ level.count }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

defineEmits(["click"]);

const props = defineProps({
  count_of_apprentice: {
    type: Number,
    default: 0,
  },
  count_of_proficient: {
    type: Number,
    default: 0,
  },
  count_of_coach: {
    type: Number,
    default: 0,
  },
  count_of_architect: {
    type: Number,
    default: 0,
  },
});

const badgeLevels = computed(() => [
  {
    key: "apprentice",
    count: Math.max(0, props.count_of_apprentice),
  },
  {
    key: "proficient",
    count: Math.max(0, props.count_of_proficient),
  },
  {
    key: "coach",
    count: Math.max(0, props.count_of_coach),
  },
  {
    key: "architect",
    count: Math.max(0, props.count_of_architect),
  },
]);
</script>

<style scoped>
.employee-badge-counter {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter, sans-serif;
  padding: 10px;
  border-radius: 6px;
  width: fit-content;
}

.employee-badge-counter:hover {
  background: #F4EBFF;
  cursor: url("../assets/cursorArrow.svg"), auto;
}

.employee-badge-counter__badge {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 500;
}

.employee-badge-counter__badge--apprentice {
  border: 1px solid #E58700;
  background: #FFF5D3;  
  color: #E58700;
}

.employee-badge-counter__badge--proficient {
  border: 1px solid #00B813;
  background: #F3FFF9;
  color: #00B813;
}

.employee-badge-counter__badge--coach {
  border: 1px solid #00A3FF;
  background: #F2F6FF;
  color: #00A3FF;
}

.employee-badge-counter__badge--architect {
  border: 1px solid #2E1EC1;
  background: #F1EFFF;
  color: #2E1EC1;
}
</style>
